<template>
  <div
    class="indicator-box m-chart-block"
    :class="{ 'indicator-box--subtle': subtle }"
  >
    <h4 class="indicator__title" v-if="title">{{ title }}</h4>
    <slot />
    <div class="indicators__wrapper">
      <div
        v-for="indicator in Object.keys(indicators)"
        :key="indicator"
        class="indicator"
      >
        <span class="f-ui-3">{{ indicator }}</span>
        <span class="indicator__value f-ui-1" v-html="indicators[indicator]">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    indicators: {
      type: Object,
      required: true,
    },
    subtle: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.indicator-box {
  color: #fff;
  background: #04f;
  margin: 25px 0;
}
.indicator-box--subtle {
  color: inherit;
  background: #e6e6e6;
}
.indicators__wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0 20px 32px 0;
}
.indicator__title {
  font-size: 1.25rem;
  line-height: 1.25rem;
  font-weight: 600;
  position: relative;
  color: #fff;
  margin: 0;
  padding: 16px 20px;
}
.indicator__title:after {
  display: block;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background: #fff;
  content: "";
  opacity: 0.2;
  pointer-events: none;
}
.indicator-box--subtle .indicator__title {
  color: inherit;
}
.indicator-box--subtle .indicator__title:after {
  background: #000;
}
.indicator-box--subtle .indicator:nth-child(n + 3) {
  border-top: 1px solid hsla(0, 0%, 0%, 0.2);
}
.indicator {
  flex-grow: 1;
  width: calc(50% - 20px);
  margin-left: 20px;
  margin-top: 16px;
  padding-top: 24px;
}
@media screen and (max-width: 960px) {
  .indicator {
    width: 100%;
  }
}
.indicator:nth-child(n + 3) {
  border-top: 1px solid hsla(0, 0%, 100%, 0.2);
}
.indicator span {
  display: block;
}
.indicator .indicator__value {
  padding-top: 16px;
  white-space: pre-wrap;
}
</style>